import { RadioGroup, RadioGroupItem } from "~/components/ui/radio-group";
import { Label } from "~/components/ui/label";
import { SingleDatePicker } from "~/components/PublicationDateSelect";

interface Props {
  value: Date | null | undefined;
  onChange: (a: Date | null) => void;
  disabled?: boolean;
  startDate?: Date;
}

const NEVER = "null";

const ExpirationDateSelect = (props: Props) => {
  const { value, onChange } = props;
  const disabled = props.disabled ?? false;
  const todayPrecise = props.startDate ? props.startDate : new Date();
  const today = new Date(todayPrecise.getFullYear(), todayPrecise.getMonth(), todayPrecise.getDate());
  const nextYear = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
  const sixYears = new Date(today.getFullYear() + 6, today.getMonth(), today.getDate());
  const tenYears = new Date(today.getFullYear() + 10, today.getMonth(), today.getDate());
  const twentyYears = new Date(today.getFullYear() + 20, today.getMonth(), today.getDate());
  const expDateOptions = [
    { value: nextYear.toString(), label: "1 year" },
    { value: sixYears.toString(), label: "6 years" },
    { value: tenYears.toString(), label: "10 years" },
    { value: twentyYears.toString(), label: "20 years" },
    { value: NEVER, label: "Never" },
  ];

  const selected = value === undefined ? "" : value === null ? NEVER : String(value);

  return (
    <div className="flex flex-col gap-3">
      <SingleDatePicker
        value={value ?? undefined}
        onChange={(d) => onChange(d ?? null)}
        allowPast={false}
        disabled={disabled}
        helperText="Select a custom expiration date"
      />
      <RadioGroup
        value={selected}
        onValueChange={(v) => onChange(v === NEVER ? null : new Date(v))}
        disabled={disabled}
        className="gap-2"
      >
        {expDateOptions.map((opt) => (
          <div key={opt.value} className="flex items-center gap-2">
            <RadioGroupItem id={`exp-${opt.value}`} value={opt.value} />
            <Label htmlFor={`exp-${opt.value}`} className="cursor-pointer font-normal">
              {opt.label}
            </Label>
          </div>
        ))}
      </RadioGroup>
    </div>
  );
};

export default ExpirationDateSelect;
